import {createMuiTheme} from '@material-ui/core/styles';

export const spacingUnit = 8;

import {
    CONIFER,
    SUMMER,
    SNOW_BLIND,
    GRANITE_9,
    GRANITE_8,
    GRANITE_7,
    GRANITE_6,
    GRANITE_5,
    GRANITE_4,
    GRANITE_3,
    GRANITE_2,
    GRANITE_1
} from './colors';

// Include rules in here only if they're meant to apply website-wide.
// One-off changes should be implemented downstream.
export default createMuiTheme({
    palette: {
        primary: {main: CONIFER},
        secondary: {main: SUMMER},
        error: {main: SUMMER},

        grey: {
            50: SNOW_BLIND,
            100: GRANITE_9,
            200: GRANITE_8,
            300: GRANITE_7,
            400: GRANITE_6,
            500: GRANITE_5,
            600: GRANITE_4,
            700: GRANITE_3,
            800: GRANITE_2,
            900: GRANITE_1
        }
    },

    typography: {
        fontSize: 11,
        htmlFontSize: 10,
        fontFamily: ['Arimo', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],

        button: {
            textTransform: 'none',
            fontSize: 15
        },

        caption: {
            fontSize: 11
        }
    },

    spacing: {
        unit: spacingUnit
    },

    props: {
        MuiIconButton: {
            disableRipple: true,
        },

        MuiExpansionPanel: {
            elevation: 0
        },

        MuiMenu: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            },
            getContentAnchorEl: null
        }
    },

    overrides: {

        MuiListItemSecondaryAction: {
            root: {
                top: spacingUnit,
                right: 0,
                transform: null
            }
        },

        MuiListSubheader: {
            root: {
                borderBottomColor: GRANITE_7,
                borderBottomStyle: 'solid',
                borderBottomWidth: 1,
                lineHeight: null,
                marginBottom: spacingUnit,
                paddingBottom: spacingUnit / 2,
                paddingTop: spacingUnit * 2,
                fontSize: 12,
            },

            sticky: {
                backgroundColor: SNOW_BLIND
            }
        },

        MuiListItemText: {
            root: {
                paddingRight: spacingUnit * 2,
                paddingLeft: spacingUnit * 2,
                alignSelf: 'flex-start'
            },

            secondary: {
                fontSize: 10
            }
        },

        MuiListItem: {
            root: {
                paddingTop: spacingUnit,
                paddingBottom: spacingUnit
            }
        },

        MuiIconButton: {
            root: {
                padding: 0,
                opacity: 0.4,
                backgroundColor: 'transparent !important',
                '&:hover': {
                    opacity: 1,
                },
            }
        },

        MuiAvatar: {
            root: {
                border: `1px solid ${GRANITE_7}`,
                borderRadius: spacingUnit
            }
        },

        MuiExpansionPanel: {
            root: {
                // Keep the "after" divider when the panel is expanded
                '&$expanded + &': {'&:before': {display: null}}
            },

            expanded: {
                margin: 0,

                // Keep the "before" divider when the panel is expanded
                '&:before': {opacity: 1}
            }
        },

        MuiExpansionPanelSummary: {
            root: {
                paddingLeft: 0,
                fontSize: 15,
            },

            expandIcon: {
                right: 0,
            },

            content: {
                '&$expanded': {
                    marginBottom: 0,
                },
            }
        },

        MuiExpansionPanelDetails: {
            root: {
                paddingLeft: 0,
                paddingRight: 0
            }
        },

        MuiToolbar: {
            root: {
                width: '100%',
                maxWidth: 1170,
                margin: '0 auto'
            }
        },

        MuiTooltip: {
            tooltip: {
                fontSize: 12
            }
        },

        MuiMenuItem: {
            root: {
                color: GRANITE_2,
                textDecoration: 'none',
                fontSize: 14,
                '&:hover': { color: GRANITE_1 },
                '&:focus': {
                    color: GRANITE_2,
                    outline: 0,
                    textDecoration: 'none'
                }
            }
        },

        // TODO revisit these styles
        MuiInput: {
            root: {
                border: '1px solid #E6E8E8',
                padding: '8px !important',
                background: '#F3F7F7',
                marginBottom: 12,
            },
            underline: {
                '&:hover:not($disabled):after': {
                    borderBottomColor: 'transparent',
                },
                '&:hover:not($disabled):before': {
                    borderBottomColor: 'transparent',
                },
                '&:after': {
                    borderBottomColor: 'transparent !important',
                    transition: 'none',
                },
                '&:before': {
                    borderBottomColor: 'transparent !important',
                    transition: 'none',
                },
            },
        }
    }
});
